import { render, staticRenderFns } from "./CollpaseEdad.vue?vue&type=template&id=48f31cbc&scoped=true&"
import script from "./CollpaseEdad.vue?vue&type=script&lang=js&"
export * from "./CollpaseEdad.vue?vue&type=script&lang=js&"
import style0 from "./CollpaseEdad.vue?vue&type=style&index=0&id=48f31cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f31cbc",
  null
  
)

export default component.exports